import { useEffect, useState } from 'react';

const HIGHLIGHT_DURATION_MS = 5000;

export const useFadingHighlight = () => {
    const [highlightedId, setHighlightedId] = useState<string | null>(null);

    useEffect(() => {
        if (!highlightedId) return;
        const timer = setTimeout(() => setHighlightedId(null), HIGHLIGHT_DURATION_MS);
        return () => clearTimeout(timer);
    }, [highlightedId]);

    return [highlightedId, setHighlightedId] as const;
};
